<template>
    <div class="grin-container">
        <g-level v-if="!isCompleted">
            <g-level-item>
                <g-button
                    shape="circle"
                    icon="arrow-left"
                    size="xlarge"
                    theme="live"
                    :disabled="isPreview"
                    @click="attemptExit"
                />
            </g-level-item>
            <g-level-item slot="center" class="flex-column">
                <g-progress
                    type="stepper"
                    :current-step="currentStep"
                    :total-steps="totalSteps"
                />
                <g-typography tag="div" color="secondary">
                    Step {{ currentStep }} of {{ totalSteps }}
                </g-typography>
            </g-level-item>
            <g-level-item slot="right">
                <g-button
                    shape="circle"
                    icon="arrow-right"
                    theme="live"
                    type="primary"
                    size="xlarge"
                    :loading="loading"
                    :disabled="isNextDisabled || isPreview"
                    @click="goNextStep"
                />
            </g-level-item>
        </g-level>

        <g-button
            v-else
            :disabled="loading || isNextDisabled || isPreview"
            :loading="loading"
            shape="round"
            theme="live"
            type="primary"
            size="xlarge"
            block
            @click="$emit('go-next-step')">
            Save
        </g-button>

        <global-exit-modal
            :visible="exitModal"
            @global-modal-exit="continueToExit"
            @global-modal-cancel="preventExit"
        />
    </div>
</template>

<script>
    import GlobalExitModal from './GlobalExitModal';
    import GlobalExitModalMixin from '../mixins/GlobalExitModalMixin';
    import ActivationBriefProgressMixin from '../mixins/ActivationBriefProgressMixin';

    export default {
        name:       'StepFooter',
        components: {
            GlobalExitModal,
        },
        mixins: [
            GlobalExitModalMixin,
            ActivationBriefProgressMixin,
        ],
        props: {
            isNextDisabled: {
                type:    Boolean,
                default: true,
            },
            loading: {
                type:    Boolean,
                default: false,
            },
            stepCompleted: {
                type:    Boolean,
                default: false,
            },
            isPreview: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                leaving: false,
            };
        },
        computed: {
            isCompleted() {
                return this.stepCompleted && !this.leaving;
            },
        },
        methods: {
            continueToExit() {
                this.$emit('go-previous-step');
            },
            goNextStep() {
                this.leaving = true;
                this.$emit('go-next-step');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .grin-container {
        padding: $g-spacing-6;
    }

    .margin-bottom-small {
        margin-bottom: $g-spacing-3;
    }

    .flex-column {
        flex-direction: column;
    }
</style>
